import React, { useEffect, useState } from 'react'
import { Button, Cascader, Form, Input, Radio, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { fetchCrossDataSource, fetchCrossDataSourceTree, fetchDimensionDataSource } from '../../apis/indicator'
import { FormButton } from './indicator.styled'

function DimensionForm (props) {
  const { params, modalData, defConfig, defPlaceholder, brands, form, handleModalClose, loading, crossDataColumn, setCrossDataColumn } = props
  const { t: ln_t } = useTranslation()
  const { fetchParams } = params
  const formVal = Form.useWatch() || {}
  const [dataSource, setDataSource] = useState([])
  const [crossDataTable, setCrossDataTable] = useState([])
  const tableMapping = dataSource?.reduce((all, i) => ({ ...all, [i.dataSourceId]: i.tables?.map(j => ({ ...j, dataSourceId: i.dataSourceId })) }), {})
  const columnMapping = Object.values(tableMapping)?.flat()?.reduce((all, i) => ({ ...all, [`${i.dataSourceId}-${i.tableName}`]: i.columns }), {})
  const isCrossData = formVal.dataSourceId === 'crossData'

  const getDataSourceGeneral = async brandId => {
    const res = await fetchDimensionDataSource(brandId)
    if (res?.status === 200) setDataSource(res?.data?.filter(i => i.dataSourceId))
  }
  const getCrossDataSource = async brandId => {
    const crossData = await fetchCrossDataSource(brandId)
    if (crossData?.status === 200) setCrossDataTable(crossData?.data?.filter(i => i.id)?.map(i => ({ value: i.id, label: i.name })))
  }
  const getDataSource = async (brandId = fetchParams?.brandId) => {
    if (!brandId) return
    getDataSourceGeneral(brandId)
    getCrossDataSource(brandId)
  }

  const handleChangeBrand = e => {
    getDataSource(e)
    form.setFieldsValue({ dataSourceId: undefined, tableName: undefined, columnName: undefined })
  }

  const handleChangeTable = async (e, reset = true, initFetch) => {
    if (reset) form.setFieldsValue({ columnName: undefined })
    if (!isCrossData && !initFetch) return
    const res = await fetchCrossDataSourceTree(e, { type: 1 })
    if (res?.status !== 200) return
    const crossData = res?.data?.filter(i => i.dataSourceId)?.map(i => ({
      value: `${i?.dataSourceId}`,
      label: i?.dataSourceName,
      dataSourceType: i?.dataSourceType,
      disableCheckbox: true,
      children: i.tables?.map(table => ({
        value: table?.tableName,
        label: table?.tableName,
        disableCheckbox: true,
        children: table?.columns?.map(col => ({
          value: col?.columnName,
          label: col?.alias || col?.columnName
        }))
      }))
    }))
    setCrossDataColumn(crossData)
  }

  useEffect(() => {
    if (modalData?.open) getDataSource(modalData?.data?.brandId)
    if (modalData?.data?.id) handleChangeTable(modalData?.data?.tableName, false, true)
  }, [modalData?.open])

  return <>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '24px 0 16px' }}>
      <div style={{ fontSize: '14px', fontWeight: 500 }}>{ln_t('util.brand')} :</div>
      <Form.Item {...defConfig('brandId', 'input')} label="" initialValue={fetchParams?.brandId || undefined} style={{ marginBottom: 0 }}>
        <Select
          showSearch
          placeholder={defPlaceholder('brandId', 'select')}
          optionFilterProp="children"
          options={brands}
          style={{ minWidth: '120px' }}
          onChange={handleChangeBrand}
        />
      </Form.Item>
    </div>
    <Form.Item {...defConfig('name', 'input')}>
      <Input placeholder={defPlaceholder('name', 'input')} />
    </Form.Item>
    <Form.Item {...defConfig('status', 'select')} initialValue={1}>
      <Radio.Group
        options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
        optionType="button"
        buttonStyle="solid"
      />
    </Form.Item>
    <Form.Item {...defConfig('dataSourceId', 'input')} >
      <Select
        showSearch
        placeholder={defPlaceholder('dataSourceId', 'select')}
        optionFilterProp="children"
        options={[...dataSource?.map(i => ({ value: i.dataSourceId, label: i.dataSourceName })), { value: 'crossData', label: ln_t('indicator.crossDataSource') }]}
        disabled={!formVal.brandId || modalData?.viewOnly}
        onChange={() => form.setFieldsValue({ tableName: undefined, columnName: undefined })}
      />
    </Form.Item>
    <Form.Item {...defConfig('tableName', 'input')} >
      <Select
        showSearch
        placeholder={defPlaceholder('tableName', 'select')}
        optionFilterProp="children"
        options={isCrossData ? crossDataTable : tableMapping[formVal.dataSourceId]?.map(i => ({ value: i.tableName, label: i.tableName }))}
        disabled={!formVal.dataSourceId || modalData?.viewOnly}
        onChange={handleChangeTable}
      />
    </Form.Item>
    <Form.Item {...defConfig('columnName', 'input')} >
      {isCrossData
        ? <Cascader
            expandTrigger="hover"
            multiple
            popupClassName="cascader-hide-disabled-checkbox"
            showCheckedStrategy={Cascader.SHOW_CHILD}
            placeholder={defPlaceholder('columnName', 'select')}
            options={crossDataColumn}
            disabled={!formVal.tableName || modalData?.viewOnly}
            // tagRender={({ value }) => <Tag closable>{value?.split('__RC_CASCADER_SPLIT__')?.join(' / ')}</Tag>}
          />
        : <Select
          showSearch
          mode="tags"
          placeholder={defPlaceholder('columnName', 'select')}
          optionFilterProp="children"
          options={columnMapping[`${formVal.dataSourceId}-${formVal.tableName}`]?.map(i => ({ value: i.columnName, label: i.columnName }))}
          disabled={!formVal.tableName || modalData?.viewOnly}
        />}
    </Form.Item>

    {!modalData?.viewOnly && <FormButton>
      <Button type="default" onClick={handleModalClose}>{ln_t('util.cancel')}</Button>
      <Button type="primary" htmlType="submit" loading={loading}>{ln_t('util.confirm')}</Button>
    </FormButton>}
  </>
}

export default DimensionForm
